// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center {
  margin: auto;
  width: 50%;
  padding: 10px;
  text-align: center;
}

table {
  width: 100%;
  display: none;
}

.hidden-scanner {
  display: none;
}

.custom-button-izberi {
  background-color: orange;
  color: white;
}

.documents-card {
  margin-bottom: 25px;
  max-width: 800px;
  margin: auto;
  width: 95%;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;
}

.documents-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.mat-card-actions {
  margin-right: 16px;
  display: flex;
  justify-content: flex-end;
}

.mat-flat-button{
  margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/aplikacija/aplikacija-home/aplikacija-home.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".center {\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n  text-align: center;\n}\n\ntable {\n  width: 100%;\n  display: none;\n}\n\n.hidden-scanner {\n  display: none;\n}\n\n.custom-button-izberi {\n  background-color: orange;\n  color: white;\n}\n\n.documents-card {\n  margin-bottom: 25px;\n  max-width: 800px;\n  margin: auto;\n  width: 95%;\n  padding: 10px;\n  margin-top: 10px;\n  cursor: pointer;\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.documents-card:hover {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.mat-card-actions {\n  margin-right: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.mat-flat-button{\n  margin: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
